import { render, staticRenderFns } from "./MakeRequests.vue?vue&type=template&id=8125fcac&scoped=true&"
import script from "./MakeRequests.vue?vue&type=script&lang=js&"
export * from "./MakeRequests.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./MakeRequests.vue?vue&type=style&index=1&id=8125fcac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8125fcac",
  null
  
)

export default component.exports